import { useEffect, useState } from "react";
import styles from "./login.module.css";
import { toast } from "react-hot-toast";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [emailSubmited, setEmailSubmited] = useState(false);
  const [otp, setOtp] = useState("");
  const [token, setToken] = useState("");
  const [showError, setShowError] = useState("granted");
  const [resendOtpLoading, setResendOtpLoading] = useState(false);
  const [counter, setCounter] = useState(0);

  const sentOtp = () => {
    setLoading(true);
    setLoading(false);
    setToken("logged-in");
    setEmailSubmited(true);
    setCounter(60);
  };

  const handleOtp = () => {
    if (!email) {
      toast.error("Email is required.");
    } else if (email !== "admin@girnarsoft.com") {
      toast.error("Email is invalid.");
    } else {
      sentOtp();
    }
  };

  const handleLogin = () => {
    if (!otp) {
      toast.error("OTP is required.");
    } else {
      if (otp === "1234567890" && email === "admin@girnarsoft.com") {
        localStorage.setItem("GIRNAR_TOKEN", "logged-in");
        window.location.reload();
      } else if (email === "admin@girnarsoft.com") {
        toast.error("Invalid OTP");
      } else {
        toast.error("Wrong credentials.");
      }
    }
  };

  const resendOtp = () => {
    setResendOtpLoading(true);
  };

  useEffect(() => {
    counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);
  }, [counter]);

  return (
    <div className={styles.container}>
      <div className={`${styles.main}`}>
        <div
          className={`${styles.slide} ${emailSubmited ? styles.forward : ""}`}
        >
          {showError === "granted" && (
            <>
              {/* modal container 1 */}
              <div className={styles.modal_container}>
                <div className={styles.modal}>
                  <h1>Dashboard Login</h1>
                  <div className={styles.fields_container}>
                    <div className={styles.label_and_field}>
                      <span>Email</span>
                      <input
                        type="email"
                        placeholder="Enter email address"
                        value={email}
                        onChange={(e) => {
                          setEmail(e.target.value);
                        }}
                      />
                      <button onClick={handleOtp} disabled={loading}>
                        {loading ? (
                          <span className={styles.loader}></span>
                        ) : (
                          <>Request OTP</>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* modal container 2 */}
              <div className={styles.modal_container_2}>
                <div className={styles.modal}>
                  <h1>Confirm OTP</h1>
                  <div className={styles.fields_container}>
                    <div className={styles.label_and_field}>
                      <span>OTP</span>
                      <input
                        type="password"
                        placeholder="Enter otp received."
                        value={otp}
                        onChange={(e) => {
                          setOtp(e.target.value);
                        }}
                      />
                      <button
                        onClick={() => {
                          setEmailSubmited(true);
                          handleLogin();
                        }}
                      >
                        Login
                      </button>
                      {/* {counter === 0 ? (
                        <button
                          style={{
                            background: "transparent",
                            color: "#fff",
                            textDecoration: "underline",
                            height: "40px",
                            marginTop: "10px",
                            paddingTop: "0px",
                          }}
                          onClick={() => {
                            resendOtp();
                          }}
                          disabled={resendOtpLoading}
                        >
                          {resendOtpLoading ? (
                            <span
                              className={styles.loader}
                              style={{
                                borderColor: "#fff",
                                borderBottomColor: "transparent",
                              }}
                            ></span>
                          ) : (
                            <>Resend OTP</>
                          )}
                        </button>
                      ) : (
                        <p
                          style={{
                            textAlign: "center",
                            marginTop: "20px",
                            opacity: ".5",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <span
                            style={{
                              textDecoration: "underline",
                              display: "inline-block",
                            }}
                          >
                            Resend OTP
                          </span>{" "}
                          - {counter} sec
                        </p>
                      )} */}
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}

          {showError === "paused" ||
            (showError === "suspended" && (
              <div className={styles.modal_container}>
                <div className={styles.modal}>
                  <h1>Error for {showError}</h1>
                </div>
              </div>
            ))}
        </div>
        {/* back button */}
        <div className={styles.arrow_container}>
          <div
            className={`${styles.back_arrow} ${
              emailSubmited ? styles.show_arrow : ""
            }`}
            onClick={() => {
              setEmailSubmited(false);
            }}
          >
            <FontAwesomeIcon icon={faArrowLeft} />
          </div>
        </div>
      </div>
      <div className={styles.carousel}></div>
    </div>
  );
};

export default Login;
